import React from 'react';
import style from './style.scss';

class ProductDetailCollapse extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false
    };
  }

  collapse() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <section className="product-detail-collapse">
        <div className={this.state.isOpen ? 'fix-content open' : 'fix-content'}>
          <h3 className='title-collapse' onClick={this.collapse.bind(this)}>Chi tiết sản phẩm</h3>
        </div>
        <div className={this.state.isOpen ? 'collapse-content open' : 'collapse-content'} dangerouslySetInnerHTML={{__html: this.props.productContent}}></div>
      </section>
    );
  }
}

export default ProductDetailCollapse;



// WEBPACK FOOTER //
// ./components/product-detail/sub-view/product-detail/ProductDetailCollapse.jsx